const _lg = "0px 10px 15px -5px rgba(0, 0, 0, 0.12)"
const _xl = "0px 20px 15px -3px rgba(0, 0, 0, 0.12)"
const _2xl = "0px 25px 50px -12px rgba(0, 0, 0, 0.25)"
const config = { "lg": _lg, "xl": _xl, "2xl": _2xl,  }
export { config as default, _lg, _xl, _2xl }